var _style, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoviet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 173",
    style: {
      enableBackground: "new 0 0 400 173"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0 {\r\n\t\t\tfill: url(#SVGID_1_);\r\n\t\t}\r\n\r\n\t\t.st1 {\r\n\t\t\tfill: #434243;\r\n\t\t}\r\n\r\n\t\t.st2 {\r\n\t\t\tfill: #254393;\r\n\t\t}\r\n\t")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -222.5764,
    y1: 274.7468,
    x2: -221.394,
    y2: 274.7468,
    gradientTransform: "matrix(0 -56.126 -56.126 0 15486.2373 -12374.0156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#254393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    style: {
      stopColor: "#286EB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9AD5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,51.9L15.7,85.1l33.2,33.2h34l33.1-33.2L82.8,51.9H48.8z M105.7,85.1L79.8,111L53.9,85.1v0l6.2-6.2h11.3 l6.2,6.2l-3.4,3.4l5.5,5.5l9-9l8.5-8.5L105.7,85.1z M83.2,79.6l-8.4-8.4h-18l-14,14L68.8,111H51.8L25.9,85.1l25.9-25.9h27.9 l11.9,11.9L83.2,79.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.9,65.2c0-5.3-3.5-9.1-10.3-9.1h-12.3v26.7h6.1v-8.5h3.4l6.4,8.5h6.8l-6.9-9 C185.6,72.6,187.9,69.3,187.9,65.2 M177,68.9h-5.6v-7.4h5.6c3,0,4.6,1.3,4.6,3.7C181.6,67.6,180,68.9,177,68.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "202.9,67.4 196.3,56.1 189.4,56.1 199.9,73.2 199.9,82.8 205.9,82.8 205.9,73.1 216.4,56.1  209.5,56.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M231.4,56.1h-12.1v26.7h6.1v-8.3h6c6.8,0,10.3-3.8,10.3-9.2S238.2,56.1,231.4,56.1 M230.8,69h-5.4v-7.4h5.4 c2.9,0,4.5,1.3,4.5,3.7C235.4,67.7,233.8,69,230.8,69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "244,61.6 251.9,61.6 251.9,82.8 257.9,82.8 257.9,61.6 265.8,61.6 265.8,56.1 244,56.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M282.3,55.6c-7.9,0-14.1,6.1-14.1,13.8c0,7.7,6.2,13.8,14.1,13.8c7.9,0,14.1-6.1,14.1-13.8 C296.3,61.7,290.1,55.6,282.3,55.6 M282.3,77.4c-4.3,0-7.8-3.3-7.8-8c0-4.6,3.5-8,7.8-8c4.3,0,7.8,3.3,7.8,8 C290.1,74.1,286.6,77.4,282.3,77.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "312,75 304.8,56.1 298.1,56.1 308.9,82.8 315.1,82.8 325.9,56.1 319.3,56.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.7,
    y: 56.1,
    className: "st1",
    width: 6.1,
    height: 26.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "339.3,82.8 359.5,82.8 359.5,77.3 345.4,77.3 345.4,72.1 358.3,72.1 358.3,66.6 345.4,66.6  345.4,61.6 359.5,61.6 359.5,56.1 339.3,56.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "362.5,56.1 362.5,61.6 370.4,61.6 370.4,82.8 376.5,82.8 376.5,61.6 384.3,61.6 384.3,56.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.8,77.4c-4.5,0-7.9-3.3-7.9-8c0-4.7,3.4-8,7.9-8c3.9,0,6.2,1.9,7,4.7l4.6-4.6c-2.4-3.7-6.8-5.9-11.7-5.9 c-8,0-14.1,6.1-14.1,13.8c0,7.7,6.1,13.8,14.1,13.8c6.7,0,12.4-4.1,13.4-10.5h-6.3C154,75.4,151.8,77.4,147.8,77.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.6,97.3h3v17h-3V97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143,97.3h2.8l9.1,11.8V97.3h2.9v17h-2.5l-9.4-12.1v12.1H143V97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164,97.3h12.7v2.7H167v4.6h8.6v2.7H167v6.9h-3V97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.9,105.9L180.9,105.9c0-2.5,0.8-4.6,2.5-6.3c1.7-1.7,3.8-2.6,6.4-2.6c2.6,0,4.7,0.9,6.4,2.6 c1.7,1.7,2.5,3.7,2.5,6.2v0c0,2.4-0.8,4.5-2.5,6.2c-1.7,1.7-3.8,2.6-6.4,2.6c-2.6,0-4.7-0.9-6.4-2.6 C181.7,110.4,180.9,108.3,180.9,105.9z M195.6,105.9L195.6,105.9c0-1.7-0.5-3.2-1.6-4.3c-1.1-1.2-2.5-1.8-4.2-1.8s-3,0.6-4.1,1.8 c-1.1,1.1-1.6,2.6-1.6,4.3v0c0,1.7,0.5,3.1,1.6,4.3c1.1,1.2,2.5,1.8,4.2,1.8c1.7,0,3-0.6,4.1-1.8 C195.1,109,195.6,107.6,195.6,105.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoviet);
export default __webpack_public_path__ + "static/media/cryptoviet.c98a44f75b0e13e14d3dfdf229f3e61d.svg";
export { ForwardRef as ReactComponent };